import { defineComponent as _defineComponent } from 'vue'
import { Skeleton, Spin, Pagination, Empty, message } from 'ant-design-vue'
import { useRouter } from '@/hooks/useRouter'
import { webListUser, webListUserVisitors } from '@/api/user'
import useList from '@/hooks/useList'
import { computed, onMounted, watch } from 'vue'
import useInit from '@/hooks/useInit'
import { useAppStore } from '@/store/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolPeopleList',
  props: {
    university: null,
    year: null,
    needLoading: { type: Boolean },
    filterKey: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  university?: string
  year?: number
  needLoading: boolean
  filterKey?: 'workCity' | 'workIndustry' | 'university' | 'schoolStartDate'
};



const listApi = computed(() => {
  if (props.needLoading) {
    return webListUser
  }
  return webListUserVisitors
})
const store = useAppStore()

const { dataList, loading, pagination, onSearch } = useList<AnyObject>({
  getList: listApi,
  mountedRequest: false,
  formatGetListQuery(query) {
    if (props.needLoading && props.filterKey) {
      if (!store.realName) {
        return false
      }
      return {
        ...query,
        [props.filterKey]: store[props.filterKey] || '',
      }
    }
    if (!props.university) {
      return false
    }
    return {
      ...query,
      university: props.university,
      schoolStartDate: props.year,
    }
  },
})

watch(
  () => store.realName,
  (val, prevV) => {
    if (prevV === undefined && val) {
      onSearch({})
    }
  }
)

watch(
  () => [pagination.current, pagination.pageSize],
  () => {
    onSearch({})
  }
)

const { loading: skeletonLoading } = useInit(dataList)

onMounted(() => {
  if (props.needLoading && store.token) {
    onSearch({})
  } else {
    dataList.value = []
  }
})

expose({
  onQuery: onSearch,
})

const router = useRouter()
function toPeopleDetail(item: AnyObject) {
  const route = router.currentRoute
  if (store.token) {
    if (item.openFlag === 'Y') {
      router.push({
        path: `/addressBook/peopleDetail/${item.userId}`,
        query: {
          form: route.path,
        },
      })
    } else {
      message.info('该校友信息未公开')
    }
  } else {
    message.info('请登录后查看')
  }
}

return { __sfc: true,props, listApi, store, dataList, loading, pagination, onSearch, skeletonLoading, router, toPeopleDetail, Skeleton, Spin, Pagination, Empty }
}

})